webpackJsonp([1,2],Array(28).concat([
/* 28 */
/* exports provided: isObject, hasProp, objHasProp, findForm, findFormOffset */
/* exports used: objHasProp */
/*!************************************!*\
  !*** ./client/store/util/utils.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* unused harmony export hasProp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return objHasProp; });
/* unused harmony export findForm */
/* unused harmony export findFormOffset */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isObject = function isObject(value) {
	/**@TODO npm in just this function from lodash, beacuse the fact that I copypasted 3 lines of code is THE WORST THING EVER! https://github.com/lodash/lodash/blob/master/isObject.js **/
	var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	return value != null && (type == 'object' || type == 'function');
	//Look - I added semicolons
};

var hasProp = function hasProp(maybeObj, prop) {
	return isObject(maybeObj) && objHasProp(maybeObj, prop);
};

var objHasProp = function objHasProp(obj, prop) {
	return Object.prototype.hasOwnProperty.call(obj, prop);
};

var findForm = function findForm(state, formId) {
	return state.forms.find(function (form) {
		return form.form_id === formId;
	});
};

var findFormOffset = function findFormOffset(state, formId) {
	return state.forms.findIndex(function (form) {
		return form.form_id === formId;
	});
};

/***/ }),
/* 29 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./client/store/util/wpConfig.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
	/**
  * The URL for local site API
  *
  * @since 0.0.1
  *
  * @type {string}
  */
	localApiURL: CF_PRO_ADMIN.api.cf.url,

	/**
  * The nonce for local site API
  *
  * @since 0.0.1
  *
  * @type {string}
  */
	localApiNonce: CF_PRO_ADMIN.api.cf.nonce,

	/**
  * The URL for remote app API
  *
  * @since 0.0.1
  *
  * @type {string}
  */
	appURL: CF_PRO_ADMIN.api.cfPro.url,

	/**
  * The ID of the form whose edit screen we are on
  *
  * @since 1.0.0
  *
  * @type {string}
  */
	formScreen: CF_PRO_ADMIN.formScreen,

	/**
  * Translation and other strings.
  *
  * Created by "strings" index of generated in calderawp\calderaforms\pro\admin\scripts::data()
  *
  * @since 1.0.0
  *
  * @type {Object}
  */
	strings: CF_PRO_ADMIN.strings,

	/**
  * Levels of Monolog logs
  *
  * Created by "logLevels" index of generated in calderawp\calderaforms\pro\admin\scripts::data()
  *
  * @since 1.5.9
  *
  * @type array
  */
	logLevels: CF_PRO_ADMIN.logLevels

};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/* unknown exports provided */
/* all exports used */
/*!******************************************!*\
  !*** ./~/browserify-aes/modes/list.json ***!
  \******************************************/
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 57 */,
/* 58 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/browserify-sign/browser/algorithms.json ***!
  \***************************************************/
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 59 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/browserify-sign/browser/curves.json ***!
  \***********************************************/
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************!*\
  !*** ./client/components/Elements/Status/Status.vue ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-b2ae9c58","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Status.vue */ 180)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Status.vue */ 126),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-b2ae9c58"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./Status.vue */ 234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************!*\
  !*** ./client/components/FormSettings/Form.vue ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./Form.vue */ 127),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-d44e4582"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Form.vue */ 235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/* exports provided: default */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_wpConfig__ = __webpack_require__(/*! ./util/wpConfig */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(/*! ./mutations */ 118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(/*! ./actions */ 116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(/*! ./getters */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins__ = __webpack_require__(/*! ./plugins */ 119);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* default */]);



var STATE = {
	loading: false,
	connected: false,
	forms: [],
	settings: {
		enhancedDelivery: false,
		generatePDFs: false,
		logLevel: 250
	},
	layouts: [{ name: '' }],
	account: {
		plan: String,
		id: Number,
		apiKeys: {
			public: String,
			secret: String,
			token: String
		}
	},
	strings: __WEBPACK_IMPORTED_MODULE_2__util_wpConfig__["a" /* default */].strings,
	mainAlert: {
		success: false,
		message: '',
		show: false
	},
	logLevels: __WEBPACK_IMPORTED_MODULE_2__util_wpConfig__["a" /* default */].logLevels
};









var PLUGINS = [__WEBPACK_IMPORTED_MODULE_6__plugins__["a" /* accountSaver */], __WEBPACK_IMPORTED_MODULE_6__plugins__["b" /* formSaver */]];

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* default */].Store({
	strict: false,
	plugins: PLUGINS,
	modules: {},
	state: STATE,
	getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* GETTERS */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* MUTATIONS */],
	actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* ACTIONS */]
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 86 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./client/views/Settings.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-16fab070","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Settings.vue */ 178)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Settings.vue */ 132),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-16fab070"}!../../~/vue-loader/lib/selector?type=template&index=0!./Settings.vue */ 227),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/* unknown exports provided */
/* exports used: default */
/*!******************************!*\
  !*** ./client/views/Tab.vue ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Tab.vue */ 133),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0b88b150"}!../../~/vue-loader/lib/selector?type=template&index=0!./Tab.vue */ 225),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./client/components/Account/display.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_css__ = __webpack_require__(/*! ./style.css */ 177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 5);



/* harmony default export */ __webpack_exports__["a"] = {
  render: function render(h) {
    return h(
      'div',
      {
        attrs: { id: 'cf-pro-account' }
      },
      [h(
        'ul',
        null,
        [h(
          'li',
          null,
          ['Public Key ', this.publicKey]
        ), h(
          'li',
          null,
          ['Secret Key ', this.secretKey]
        ), h(
          'li',
          null,
          ['Token ', this.token]
        )]
      )]
    );
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    token: function token(state) {
      return state.account.apiKeys.token;
    },
    publicKey: function publicKey(state) {
      return state.account.apiKeys.public;
    },
    secretKey: function secretKey(state) {
      return state.account.apiKeys.secret;
    }
  })

};

/***/ }),
/* 116 */
/* exports provided: ACTIONS */
/* exports used: ACTIONS */
/*!*********************************!*\
  !*** ./client/store/actions.js ***!
  \*********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_API__ = __webpack_require__(/*! ./util/API */ 120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_urlString__ = __webpack_require__(/*! ./util/urlString */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_wpConfig__ = __webpack_require__(/*! ./util/wpConfig */ 29);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





var ACTIONS = {
	getAccount: function getAccount(context) {
		return new Promise(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_0__util_API__["a" /* localAPI */].get().then(function (response) {
				var r;
				if ('string' == typeof response.data) {
					var maybe = JSON.parse(response.data);
					if ('object' === (typeof maybe === 'undefined' ? 'undefined' : _typeof(maybe))) {
						r = maybe;
					} else {
						throw new Exception();
					}
				} else {
					r = response.data;
				}
				context.commit('forms', r.forms);
				context.commit('apiKeys', r.apiKeys);
				context.commit('accountId', r.account_id);
				context.commit('plan', r.plan);
				context.commit('logLevel', r.logLevel);
				context.commit('enhancedDelivery', r.enhancedDelivery);
				context.commit('formScreen', r.hasOwnProperty('formScreen') ? r.formScreen : __WEBPACK_IMPORTED_MODULE_2__util_wpConfig__["a" /* default */].formScreen);
				resolve(response);
			}, function (error) {
				reject(error);
			});
		});
	},
	saveAccount: function saveAccount(context) {
		var key = context.state.account.apiKeys.public;
		if (key && 'string' === typeof key) {
			key = key.trim();
		}
		var secret = context.state.account.apiKeys.secret;
		if (secret && 'string' === typeof secret) {
			secret = secret.trim();
		}

		return __WEBPACK_IMPORTED_MODULE_0__util_API__["a" /* localAPI */].post('', {
			accountId: context.state.account.id,
			apiKey: key,
			apiSecret: secret,
			enhancedDelivery: context.state.settings.enhancedDelivery,
			plan: context.state.account.plan,
			forms: context.state.forms,
			logLevel: context.state.settings.logLevel
		}).then(function (r) {
			if (r.data.hasOwnProperty('_cfAlertMessage')) {
				context.dispatch('updateMainAlert', _cfAlertMessage);
			} else {
				context.dispatch('updateMainAlert', {
					message: context.state.strings.saved,
					show: true,
					success: true,
					fade: 1500
				});
			}
		});
	},
	testConnection: function testConnection(_ref) {
		var commit = _ref.commit,
		    state = _ref.state;

		return new Promise(function (resolve, reject) {
			if (state.account.apiKeys.public && state.account.apiKeys.secret) {
				return __WEBPACK_IMPORTED_MODULE_0__util_API__["b" /* appAPI */].get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_urlString__["a" /* urlString */])({
					public: state.account.apiKeys.public,
					token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_API__["c" /* appToken */])(state.account.apiKeys)
				}, '/account/verify')).then(function (r) {
					state.account.plan = r.plan;
					state.account.id = r.id;
					state.connected = true;
					commit('connected', true);
					resolve(r);
				}, function (error) {
					reject(error);
				});
			} else {
				reject('Not Connected');
			}
		});
	},
	getLayouts: function getLayouts(_ref2) {
		var commit = _ref2.commit,
		    state = _ref2.state;

		if (state.connected) {
			return __WEBPACK_IMPORTED_MODULE_0__util_API__["b" /* appAPI */].get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_urlString__["a" /* urlString */])({
				simple: true,
				public: state.account.apiKeys.public,
				token: state.account.apiKeys.token
			}, '/layouts/list')).then(function (r) {
				commit('layouts', r.data);
			}, function (e) {
				console.log(e);
			});
		}
	},

	/**
  * Set the main alert -- status.
  *
  * Using this over mutation mainAlert, which this uses, is you can send a number of milliseconds in alert.fade and it will removed in that number of milliseconds
  *
  * @since 1.0.0
  *
  * @param {*} context
  * @param {Object} alert Commit payload
  */
	updateMainAlert: function updateMainAlert(context, alert) {
		var fade = alert.hasOwnProperty('fade') && !isNaN(alert.fade) ? alert.fade : 0;
		if (fade) {
			//OMG(s) window scope.
			window.setTimeout(function () {
				context.dispatch('closeMainAlert');
			}, fade);
		}
		context.commit('mainAlert', alert);
	},

	/**
  * Make mainAlert clode
  *
  * @since 1.0.0
  *
  * @param context
  */
	closeMainAlert: function closeMainAlert(context) {
		context.dispatch('updateMainAlert', {
			show: false
		});
	}
};

/***/ }),
/* 117 */
/* exports provided: GETTERS */
/* exports used: GETTERS */
/*!*********************************!*\
  !*** ./client/store/getters.js ***!
  \*********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_utils__ = __webpack_require__(/*! ./util/utils */ 28);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GETTERS; });


var GETTERS = {
	publicKey: function publicKey(state) {
		return state.account.apiKeys.public;
	},
	secretKey: function secretKey(state) {
		return state.account.apiKeys.secret;
	},
	apiKeys: function apiKeys(state) {
		return state.account.apiKeys;
	},
	hi: function hi(state) {
		return 'Roy';
	},
	getSetting: function getSetting(state) {
		return function (setting, _default) {
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_utils__["a" /* objHasProp */])(state.settings, setting)) {
				return state.settings[setting];
			}
			return _default;
		};
	},
	getFormsById: function getFormsById(state, getters) {
		return function (id) {
			return state.forms.find(function (form) {
				return form.form_id === id;
			});
		};
	},

	enhancedDelivery: function enhancedDelivery(state) {
		return state.settings.enhancedDelivery;
	},
	logLevels: function logLevels(state) {
		return state.logLevels;
	},
	logLevel: function logLevel(state) {
		return state.settings.logLevel;
	},
	connected: function connected(state) {
		return state.connected;
	},
	formScreen: function formScreen(state) {
		return state.formScreen;
	},
	strings: function strings(state) {
		return state.strings;
	},
	mainAlert: function mainAlert(state) {
		return state.mainAlert;
	}
};

/***/ }),
/* 118 */
/* exports provided: MUTATIONS */
/* exports used: MUTATIONS */
/*!***********************************!*\
  !*** ./client/store/mutations.js ***!
  \***********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isboolean__ = __webpack_require__(/*! lodash.isboolean */ 192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isboolean__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MUTATIONS; });

var MUTATIONS = {
	publicKey: function publicKey(state, value) {
		state.account.apiKeys.public = value;
	},
	secretKey: function secretKey(state, value) {
		state.account.apiKeys.secret = value;
	},
	apiKeys: function apiKeys(state, obj) {
		state.account.apiKeys.public = obj.public;
		state.account.apiKeys.secret = obj.secret;
		state.account.apiKeys.token = obj.token;
	},
	accountId: function accountId(state, value) {
		state.account.id = value;
	},
	plan: function plan(state, value) {
		state.account.plan = value;
	},
	loading: function loading(state) {
		state.loading = !state.loading;
	},
	forms: function forms(state, value) {
		state.forms = value;
	},
	logLevels: function logLevels(state, value) {
		state.logLevels = value;
	},
	connected: function connected(state, value) {
		state.connected = value;
	},
	layouts: function layouts(state, value) {
		state.layouts = value;
	},
	form: function form(state, value) {
		var index = state.forms.findIndex(function (form) {
			return form.form_id === value.form_id;
		});
		if (-1 < index) {
			state.forms[index] = value;
		}
	},
	logLevel: function logLevel(state, value) {
		state.settings.logLevel = value;
	},
	enhancedDelivery: function enhancedDelivery(state, value) {
		if ('on' == value) {
			value = true;
		}
		state.settings.enhancedDelivery = value;
	},
	formScreen: function formScreen(state, value) {
		state.formScreen = value;
	},

	/**
  * Change the main alert
  *
  * @since 1.0.0
  *
  * @param {Object} state
  * @param {Object} value Value to set. success - boolean. show -- boolean. message -- string
  */
	mainAlert: function mainAlert(state, value) {
		state.mainAlert = {
			success: value.hasOwnProperty('success') ? value.success : false,
			message: value.hasOwnProperty('message') ? value.message : '',
			show: value.hasOwnProperty('show') ? value.show : false
		};
		//Notice, this doesn't except fade, fade isn't tracked. You want to set a fade time? Use updateMainAlert action!
	}
};

/***/ }),
/* 119 */
/* exports provided: accountSaver, formSaver */
/* exports used: accountSaver, formSaver */
/*!*********************************!*\
  !*** ./client/store/plugins.js ***!
  \*********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(/*! lodash.debounce */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountSaver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formSaver; });
var _this = this;


var accountSaver = function accountSaver(store) {
	store.subscribe(function (mutation, state) {
		var type = mutation.type;
		switch (type) {
			case 'apiKeys':
			case 'secretKey':
			case 'publicKey':
				console.log(state.connected, state.account.apiKeys.secret, state.account.apiKeys.public);

				if (!state.connected && state.account.apiKeys.secret && state.account.apiKeys.public) {
					console.log(state.connected, state.account.apiKeys.secret, state.account.apiKeys.public);

					store.dispatch('testConnection');
					store.dispatch('getLayouts');
				} else if (!state.account.apiKeys.public || !state.account.apiKeys.secret) {
					store.commit('connected', 0);
				} else {
					store.commit('connected', 0);
				}
				break;
			case 'connected':
				if (state.connected) {
					store.dispatch('getLayouts');
				}
				break;
		}
	});
};

/**
 * Plugin to save account when form settings are changed
 *
 * @since 1.0.0
 *
 * @param {Object} store
 */
var formSaver = function formSaver(store) {
	/**
  * Debounced version of saveAccount() mutation
  * @since 1.0.0
  *
  * @type {Function}
  */
	_this.debounedFormMutation = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
		store.dispatch('saveAccount');
	}, 100);

	/**
  * When form setting is mutated trigger update
  *
  * @since 1.0.0
  */
	store.subscribe(function (mutation, state) {
		if ('form' === mutation.type) {
			_this.debounedFormMutation();
		}
	});
};

/***/ }),
/* 120 */
/* exports provided: localAPI, appAPI, appToken */
/* exports used: localAPI, appAPI, appToken */
/*!**********************************!*\
  !*** ./client/store/util/API.js ***!
  \**********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wpConfig__ = __webpack_require__(/*! ./wpConfig */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_locutus_php_strings_sha1__ = __webpack_require__(/*! locutus/php/strings/sha1 */ 191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_locutus_php_strings_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_locutus_php_strings_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(/*! ./utils */ 28);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return localAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return appToken; });





var timeout = 30000;
var localAPI = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: __WEBPACK_IMPORTED_MODULE_1__wpConfig__["a" /* default */].localApiURL,
	timeout: timeout,
	headers: { 'X-WP-Nonce': __WEBPACK_IMPORTED_MODULE_1__wpConfig__["a" /* default */].localApiNonce }
});

var appAPI = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: __WEBPACK_IMPORTED_MODULE_1__wpConfig__["a" /* default */].appURL,
	timeout: timeout
});

var appToken = function appToken(apiKeys) {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* objHasProp */])(apiKeys, 'public') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* objHasProp */])(apiKeys, 'secret')) {
		var publicKey = apiKeys.public;
		var secret = apiKeys.secret;
		return __WEBPACK_IMPORTED_MODULE_2_locutus_php_strings_sha1___default()(publicKey + secret);
	}
	return '';
};

/***/ }),
/* 121 */
/* exports provided: urlString */
/* exports used: urlString */
/*!****************************************!*\
  !*** ./client/store/util/urlString.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return urlString; });
var urlString = function urlString(data, endpoint) {
	var str = "";
	for (var key in data) {
		if (str != "") {
			str += "&";
		}
		str += key + "=" + data[key];
	}
	return endpoint + '?' + str;
};

/***/ }),
/* 122 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Account/Edit.vue ***!
  \********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

	computed: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['publicKey', 'secretKey', 'connected'])),
	methods: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['publicKey', 'secretKey']), {
		publicKeyChange: function publicKeyChange(ev) {
			this.$store.commit('publicKey', ev.target.value);
		},
		secretKeyChange: function secretKeyChange(ev) {
			this.$store.commit('secretKey', ev.target.value);
		}
	})
};

/***/ }),
/* 123 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Elements/Field/Checkbox.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Parts_Label_Label_vue__ = __webpack_require__(/*! ../Parts/Label/Label.vue */ 219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Parts_Label_Label_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Parts_Label_Label_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Parts_Input_Input_vue__ = __webpack_require__(/*! ../Parts/Input/Input.vue */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Parts_Input_Input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Parts_Input_Input_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
	components: {
		_label: __WEBPACK_IMPORTED_MODULE_0__Parts_Label_Label_vue___default.a,
		_input: __WEBPACK_IMPORTED_MODULE_1__Parts_Input_Input_vue___default.a
	},
	props: {
		idAttr: {
			type: String,
			require: true
		},
		value: {
			type: String,
			required: true
		},
		setting: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		}
	}

};

/***/ }),
/* 124 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Elements/Parts/Input/Input.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
	props: {
		idAttr: {
			type: String,
			require: true
		},
		value: {
			type: String,
			required: true
		},
		setting: {
			type: String,
			required: true
		},
		type: {
			type: String,
			default: 'text'
		}
	},
	methods: {
		handle: function handle() {
			this.$store.commit(this.setting, this.value);
		}
	}

};

/***/ }),
/* 125 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Elements/Parts/Label/Label.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
	idAttr: {
		type: String,
		require: true
	},
	label: {
		type: String,
		required: true
	}
};

/***/ }),
/* 126 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Elements/Status/Status.vue ***!
  \******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
	props: ['success', 'message', 'show'],
	watch: {
		show: function show() {
			if (this.show) {
				this.$el.className = "cf-alert-wrap cf-show";
			} else {
				this.$el.className = "cf-alert-wrap cf-hide";
			}
		}
	}

};

/***/ }),
/* 127 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/FormSettings/Form.vue ***!
  \*************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Elements_Field_Checkbox__ = __webpack_require__(/*! ../Elements/Field/Checkbox */ 217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Elements_Field_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Elements_Field_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_util_utils__ = __webpack_require__(/*! ../../store/util/utils */ 28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
	components: {
		checkbox: __WEBPACK_IMPORTED_MODULE_1__Elements_Field_Checkbox___default.a
	},
	props: ['form', 'layouts'],
	computed: {
		layoutIdAttr: function layoutIdAttr() {
			return 'cf-pro-layout-' + this.form.form_id;
		},
		pdfLayoutIdAttr: function pdfLayoutIdAttr() {
			return 'cf-pro-layout-pdf-' + this.form.form_id;
		},
		attachPDFIdAttr: function attachPDFIdAttr() {
			return 'cf-pro-layout-' + this.form.form_id;
		},
		linkPDFIdAttr: function linkPDFIdAttr() {
			return 'cf-pro-layout-' + this.form.form_id;
		},
		sendLocalIdAttr: function sendLocalIdAttr() {
			return 'cf-pro-send-local-' + this.form.form_id;
		}
	},
	methods: {
		commitChange: function commitChange(what, value) {
			this.form[what] = value;
			this.$store.commit('form', this.form);
		},
		changeLayout: function changeLayout(ev) {
			this.commitChange(ev.target.value, 'layout');
		},
		changePDFLayout: function changePDFLayout(ev) {
			this.commitChange(ev.target.value, 'pdf_layout');
		},
		changeAttachPDF: function changeAttachPDF(ev) {
			this.commitChange(ev.target.value, 'attach_pdf');
		},
		changeLinkPDF: function changeLinkPDF(ev) {
			this.commitChange(ev.target.value, 'pdf_link');
		},
		changeSendLocal: function changeSendLocal(ev) {
			this.commitChange(ev.target.value, 'send_local');
		}
	}

};

/***/ }),
/* 128 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/FormSettings/Forms.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(/*! ./Form */ 84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
	components: {
		'form-setting': __WEBPACK_IMPORTED_MODULE_0__Form___default.a
	},
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
		forms: function forms(state) {
			return state.forms;
		},
		layouts: function layouts(state) {
			return state.layouts;
		}
	}),
	methods: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getLayouts'])),
	beforeMount: function beforeMount() {
		this.getLayouts();
	},
	data: function data() {
		return {
			editForm: 0,
			form: {}
		};
	},

	watch: {
		editForm: function editForm(v) {
			this.form = this.$store.getters.getFormsById(v);
		}
	}

};

/***/ }),
/* 129 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/GeneralSettings/enhancedDelivery.vue ***!
  \****************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
    computed: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['enhancedDelivery']), {
        deliveryValue: {
            get: function get() {
                return this.enhancedDelivery;
            },
            set: function set(value) {
                this.$store.commit('enhancedDelivery', value);
            }
        }
    })
};

/***/ }),
/* 130 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/GeneralSettings/logLevel.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
    computed: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['logLevels', 'logLevel', 'strings']), {
        logLevelValue: {
            get: function get() {
                return this.logLevel;
            },
            set: function set(value) {
                this.$store.commit('logLevel', value);
            }
        }
    })
};

/***/ }),
/* 131 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Link/linkKeys.vue ***!
  \*********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {

    computed: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['strings']))

};

/***/ }),
/* 132 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Settings.vue ***!
  \***********************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Account_display__ = __webpack_require__(/*! ../components/Account/display */ 115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Account_Edit__ = __webpack_require__(/*! ../components/Account/Edit */ 216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Account_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Account_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Forms__ = __webpack_require__(/*! ../components/FormSettings/Forms */ 220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GeneralSettings_enhancedDelivery__ = __webpack_require__(/*! ../components/GeneralSettings/enhancedDelivery */ 221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GeneralSettings_enhancedDelivery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_GeneralSettings_enhancedDelivery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GeneralSettings_logLevel__ = __webpack_require__(/*! ../components/GeneralSettings/logLevel */ 222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GeneralSettings_logLevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GeneralSettings_logLevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Elements_Status_Status_vue__ = __webpack_require__(/*! ../components/Elements/Status/Status.vue */ 83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Elements_Status_Status_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Elements_Status_Status_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = {
	components: {
		'account-display': __WEBPACK_IMPORTED_MODULE_1__components_Account_display__["a" /* default */],
		'account-edit': __WEBPACK_IMPORTED_MODULE_2__components_Account_Edit___default.a,
		'forms-settings': __WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Forms___default.a,
		'delivery': __WEBPACK_IMPORTED_MODULE_4__components_GeneralSettings_enhancedDelivery___default.a,
		'logs': __WEBPACK_IMPORTED_MODULE_5__components_GeneralSettings_logLevel___default.a,
		'status': __WEBPACK_IMPORTED_MODULE_6__components_Elements_Status_Status_vue___default.a
	},
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
		loading: function loading(state) {
			return state.loading;
		},
		connected: function connected(state) {
			return state.connected;
		},
		publicKey: function publicKey(state) {
			return state.account.apiKeys.public;
		},
		enhancedDelivery: function enhancedDelivery(state) {
			return state.settings.enhancedDelivery;
		},
		logLevel: function logLevel(state) {
			return state.settings.logLevel;
		},
		mainAlert: function mainAlert(state) {
			return state.mainAlert;
		}
	}),
	beforeMount: function beforeMount() {
		[].forEach.call(document.querySelectorAll('.update-nag'), function (e) {
			e.parentNode.removeChild(e);
		});

		this.$store.dispatch('getAccount');
	},

	methods: {
		save: function save() {
			this.$store.dispatch('saveAccount');
		}
	}
};

/***/ }),
/* 133 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Tab.vue ***!
  \******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(/*! lodash.debounce */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Elements_Status_Status__ = __webpack_require__(/*! ../components/Elements/Status/Status */ 83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Elements_Status_Status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Elements_Status_Status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Form_vue__ = __webpack_require__(/*! ../components/FormSettings/Form.vue */ 84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Link_linkKeys_vue__ = __webpack_require__(/*! ../components/Link/linkKeys.vue */ 223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Link_linkKeys_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Link_linkKeys_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = {
	components: {
		'form-setting': __WEBPACK_IMPORTED_MODULE_3__components_FormSettings_Form_vue___default.a,
		'link-keys': __WEBPACK_IMPORTED_MODULE_4__components_Link_linkKeys_vue___default.a,
		'status': __WEBPACK_IMPORTED_MODULE_2__components_Elements_Status_Status___default.a
	},
	methods: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapActions */])(['getLayouts', 'getAccount', 'saveAccount'])),
	beforeMount: function beforeMount() {
		var _this = this;

		this.getAccount().then(function () {
			_this.getLayouts();
			_this.form = _this.$store.getters.getFormsById(_this.formScreen);
		});
	},

	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
		layouts: function layouts(state) {
			return state.layouts;
		},
		connected: function connected(state) {
			return state.connected;
		},
		formScreen: function formScreen(state) {
			return state.formScreen;
		},
		mainAlert: function mainAlert(state) {
			return state.mainAlert;
		}
	}),
	data: function data() {
		return {
			form: {}
		};
	}
};

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/* unknown exports provided */
/* all exports used */
/*!******************************************!*\
  !*** ./~/diffie-hellman/lib/primes.json ***!
  \******************************************/
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/* unknown exports provided */
/* all exports used */
/*!*********************************!*\
  !*** ./~/elliptic/package.json ***!
  \*********************************/
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/Users/josh/sites/caldera-dev/wp-content/plugins/caldera-forms/includes/cf-pro-client"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/Users/josh/sites/caldera-dev/wp-content/plugins/caldera-forms/includes/cf-pro-client","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),
/* 177 */
/* unknown exports provided */
/*!*********************************************!*\
  !*** ./client/components/Account/style.css ***!
  \*********************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cf-pro-account-edit":"style__cf-pro-account-edit___6_kkC"};

/***/ }),
/* 178 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-16fab070","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Settings.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-a873166e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Account/Edit.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-b2ae9c58","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Elements/Status/Status.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/* unknown exports provided */
/* all exports used */
/*!*********************************!*\
  !*** ./~/parse-asn1/aesid.json ***!
  \*********************************/
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************!*\
  !*** ./client/components/Account/Edit.vue ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-a873166e","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./Edit.vue */ 179)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./Edit.vue */ 122),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-a873166e"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Edit.vue */ 233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./client/components/Elements/Field/Checkbox.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Checkbox.vue */ 123),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2a9917a3"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./Checkbox.vue */ 230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./client/components/Elements/Parts/Input/Input.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./Input.vue */ 124),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1106535b"}!../../../../../~/vue-loader/lib/selector?type=template&index=0!./Input.vue */ 226),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./client/components/Elements/Parts/Label/Label.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./Label.vue */ 125),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2218dfa2"}!../../../../../~/vue-loader/lib/selector?type=template&index=0!./Label.vue */ 228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************!*\
  !*** ./client/components/FormSettings/Forms.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./Forms.vue */ 128),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-28ee6bc4"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Forms.vue */ 229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************************!*\
  !*** ./client/components/GeneralSettings/enhancedDelivery.vue ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./enhancedDelivery.vue */ 129),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0ad2672a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./enhancedDelivery.vue */ 224),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************!*\
  !*** ./client/components/GeneralSettings/logLevel.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./logLevel.vue */ 130),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-967240fe"}!../../../~/vue-loader/lib/selector?type=template&index=0!./logLevel.vue */ 232),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/* unknown exports provided */
/* exports used: default */
/*!*********************************************!*\
  !*** ./client/components/Link/linkKeys.vue ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 8)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./linkKeys.vue */ 131),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-698469d6"}!../../../~/vue-loader/lib/selector?type=template&index=0!./linkKeys.vue */ 231),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ad2672a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/GeneralSettings/enhancedDelivery.vue ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryValue),
      expression: "deliveryValue"
    }],
    attrs: {
      "type": "checkbox",
      "id": "cf-pro-enhanced-delivery",
      "aria-describedby": "cf-pro-enhanced-delivery-desc"
    },
    domProps: {
      "checked": Array.isArray(_vm.deliveryValue) ? _vm._i(_vm.deliveryValue, null) > -1 : (_vm.deliveryValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.deliveryValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deliveryValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deliveryValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deliveryValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cf-pro-enhanced-delivery"
    }
  }, [_vm._v("\n\t\t\tEnable Enhanced Delivery\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    attrs: {
      "id": "cf-pro-enhanced-delivery-desc"
    }
  }, [_c('p', [_vm._v("If enabled, messages are sent via Caldera Forms Pro Servers")]), _vm._v(" "), (_vm.enhancedDelivery) ? _c('ul', [_c('li', [_vm._v("Forms must use database entry tracking.")]), _vm._v(" "), _c('li', [_vm._v("From Email setting will be used as the reply-to.")])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 225 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b88b150"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Tab.vue ***!
  \*************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cf-pro-form-settings"
    }
  }, [(_vm.connected) ? _c('div', [_c('form-setting', {
    attrs: {
      "form": _vm.form,
      "layouts": _vm.layouts
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.connected) ? _c('div', [_c('link-keys')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cf-pro-alert-wrap"
    }
  }, [_c('status', {
    attrs: {
      "message": _vm.mainAlert.message,
      "success": _vm.mainAlert.success,
      "show": _vm.mainAlert.show
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 226 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1106535b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Elements/Parts/Input/Input.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": _vm.type,
      "id": _vm.idAttr
    },
    on: {
      "keyup": function($event) {
        _vm.handle()
      },
      "change": function($event) {
        _vm.handle()
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 227 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-16fab070"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Settings.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cf-pro-message-settings"
    }
  }, [_c('div', {
    attrs: {
      "id": "cf-pro-message-setting-inner"
    }
  }, [_c('div', {
    staticClass: "caldera-editor-header"
  }, [_c('ul', {
    staticClass: "caldera-editor-header-nav"
  }, [_vm._m(0), _vm._v(" "), (_vm.connected) ? _c('li', {
    staticClass: "status good"
  }, [_vm._v("\n\t\t\t\t\tConnected\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.connected) ? _c('li', {
    staticClass: "status bad"
  }, [_vm._v("\n\t\t\t\t\tNot Connected\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "cf-pro-save"
  }, [_c('input', {
    staticClass: "button button-primary",
    attrs: {
      "type": "submit",
      "value": "Save"
    },
    on: {
      "click": _vm.save
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "cf-pro-alert-wrap"
    }
  }, [_c('status', {
    attrs: {
      "message": _vm.mainAlert.message,
      "success": _vm.mainAlert.success,
      "show": _vm.mainAlert.show
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "cf-pro-settings"
  }, [_c('div', [_c('tabs', {
    attrs: {
      "options": {
        useUrlFragment: false
      }
    }
  }, [_c('tab', {
    attrs: {
      "name": "Account"
    }
  }, [_c('account-edit')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Form Settings"
    }
  }, [(_vm.connected) ? _c('div', [_c('forms-settings')], 1) : _c('div', [_vm._v("\n\t\t\t\t\t\t\tYou must connected to Caldera Forms Pro First\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Settings"
    }
  }, [_c('delivery'), _vm._v(" "), _c('logs')], 1)], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "caldera-editor-logo"
  }, [_c('span', {
    staticClass: "caldera-forms-name"
  }, [_vm._v("\n\t\t\t\t\t\tCaldera Forms Pro\n\t\t\t\t\t")])])
}]}

/***/ }),
/* 228 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2218dfa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Elements/Parts/Label/Label.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": _vm.idAttr
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 229 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-28ee6bc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/FormSettings/Forms.vue ***!
  \*********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": "cf-pro-form-setting-chooser"
    }
  }, [_vm._v("\n\t\t\tChoose Form\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm),
      expression: "editForm"
    }],
    attrs: {
      "id": "cf-pro-form-setting-chooser"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editForm = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.forms), function(form) {
    return _c('option', {
      domProps: {
        "value": form.form_id
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(form.name) + "\n\t\t\t\t")])
  })], 2)])]), _vm._v(" "), (_vm.editForm) ? _c('div', [_c('form-setting', {
    attrs: {
      "form": _vm.form,
      "layouts": _vm.layouts
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 230 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9917a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Elements/Field/Checkbox.vue ***!
  \**************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.idAttr
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('_input', {
    attrs: {
      "type": _vm.checkbox,
      "idAttr": _vm.idAttr,
      "value": _vm.value,
      "setting": _vm.setting
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 231 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-698469d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Link/linkKeys.vue ***!
  \****************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.strings.apiKeysViewLink,
      "alt": _vm.strings.apiKeysViewText,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.strings.apiKeysViewText))])
},staticRenderFns: []}

/***/ }),
/* 232 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-967240fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/GeneralSettings/logLevel.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "caldera-config-group"
  }, [_c('div', {
    attrs: {
      "aria-labelledby": "minLogLevelTitle",
      "aria-describedby": "minLogLevelInfo"
    }
  }, [_c('label', {
    attrs: {
      "for": "cf-pro-form-log-level-chooser",
      "id": "minLogLevelTitle"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.strings.minLogLevelTitle) + "\n            ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "minLogLevelInfo"
    }
  }, [_vm._v(_vm._s(_vm.strings.minLogLevelInfo))])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logLevelValue),
      expression: "logLevelValue"
    }],
    attrs: {
      "id": "cf-pro-form-log-level-chooser"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.logLevelValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.logLevels), function(level) {
    return _c('option', {
      directives: [{
        name: "key",
        rawName: "v-key",
        value: (level.number),
        expression: "level.number"
      }],
      domProps: {
        "value": level.number
      }
    }, [_vm._v("\n                    " + _vm._s(level.name) + "\n                ")])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 233 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-a873166e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Account/Edit.vue ***!
  \***************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cf-pro-account-edit"
    }
  }, [_c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": "cf-pro-api-public"
    }
  }, [_vm._v("\n\t\t\tPublic Key\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicKey),
      expression: "publicKey"
    }],
    attrs: {
      "type": "text",
      "id": "cf-pro-api-public"
    },
    domProps: {
      "value": (_vm.publicKey)
    },
    on: {
      "change": _vm.publicKeyChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicKey = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": "cf-pro-api-secret"
    }
  }, [_vm._v("\n\t\t\tSecret Key\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secretKey),
      expression: "secretKey"
    }],
    attrs: {
      "type": "text",
      "id": "cf-pro-api-secret"
    },
    domProps: {
      "value": (_vm.secretKey)
    },
    on: {
      "change": _vm.secretKeyChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secretKey = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.connected) ? _c('p', [_vm._v("\n\t\tYou can find your API keys in your "), _c('a', {
    attrs: {
      "href": "https://app.calderaformspro.com/app#/account",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\tCaldera Forms Pro Account\n\t")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 234 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2ae9c58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Elements/Status/Status.vue ***!
  \*************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cf-alert-wrap cf-hide"
  }, [(_vm.show && _vm.success) ? _c('p', {
    staticClass: "cf-alert cf-alert-success"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.show && !_vm.success) ? _c('p', {
    staticClass: "cf-alert cf-alert-warning"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 235 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-d44e4582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/FormSettings/Form.vue ***!
  \********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "caldera-config-group"
  }, [(_vm.form.send_local != true) ? _c('label', {
    attrs: {
      "for": _vm.sendLocalIdAttr
    }
  }, [_vm._v("\n\t\t\t\tDisable enhanced delivery for this form\n\t\t")]) : _c('label', {
    attrs: {
      "for": _vm.sendLocalIdAttr
    }
  }, [_vm._v("\n\t\t\t\tEnhanced delivery is disabled for this form\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.send_local),
      expression: "form.send_local"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.sendLocalIdAttr
    },
    domProps: {
      "checked": Array.isArray(_vm.form.send_local) ? _vm._i(_vm.form.send_local, null) > -1 : (_vm.form.send_local)
    },
    on: {
      "change": _vm.changeSendLocal,
      "__c": function($event) {
        var $$a = _vm.form.send_local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.send_local = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.send_local = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.send_local = $$c
        }
      }
    }
  })])]), _vm._v(" "), (_vm.form.send_local != true) ? _c('div', [_c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.layoutIdAttr
    }
  }, [_vm._v("\n\t\t\t\tEmail Layout\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.layout),
      expression: "form.layout"
    }],
    attrs: {
      "id": _vm.layoutIdAttr
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.layout = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeLayout]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.layouts), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.pdfLayoutIdAttr
    }
  }, [_vm._v("\n\t\t\t\tPDF Layout\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pdf_layout),
      expression: "form.pdf_layout"
    }],
    attrs: {
      "id": _vm.pdfLayoutIdAttr
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.pdf_layout = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changePDFLayout]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.layouts), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.attachPDFIdAttr
    }
  }, [_vm._v("\n\t\t\t\tAttach PDF To Main Mailer\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.attach_pdf),
      expression: "form.attach_pdf"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.attachPDFIdAttr
    },
    domProps: {
      "checked": Array.isArray(_vm.form.attach_pdf) ? _vm._i(_vm.form.attach_pdf, null) > -1 : (_vm.form.attach_pdf)
    },
    on: {
      "change": _vm.changeAttachPDF,
      "__c": function($event) {
        var $$a = _vm.form.attach_pdf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.attach_pdf = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.attach_pdf = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.attach_pdf = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.attachPDFIdAttr
    }
  }, [_vm._v("\n\t\t\t\tAdd PDF Link\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pdf_link),
      expression: "form.pdf_link"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.attachPDFIdAttr
    },
    domProps: {
      "checked": Array.isArray(_vm.form.pdf_link) ? _vm._i(_vm.form.pdf_link, null) > -1 : (_vm.form.pdf_link)
    },
    on: {
      "change": _vm.changeLinkPDF,
      "__c": function($event) {
        var $$a = _vm.form.pdf_link,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.pdf_link = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.pdf_link = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.pdf_link = $$c
        }
      }
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */
/* unknown exports provided */
/* all exports used */
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 239 */
/* unknown exports provided */
/* all exports used */
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 240 */
/* unknown exports provided */
/* all exports used */
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 241 */
/* exports provided: store */
/* all exports used */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(/*! ./store */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Settings_vue__ = __webpack_require__(/*! ./views/Settings.vue */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tabs_component__ = __webpack_require__(/*! vue-tabs-component */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tabs_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tabs_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Tab_vue__ = __webpack_require__(/*! ./views/Tab.vue */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Tab_vue__);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "store", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('tabs', __WEBPACK_IMPORTED_MODULE_3_vue_tabs_component__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('tab', __WEBPACK_IMPORTED_MODULE_3_vue_tabs_component__["Tab"]);

//@TODO Remove this hack-ass way of selecting which app to run

if (document.getElementById('cf-pro-app')) {
	var mainSettingsApp = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
		el: '#cf-pro-app',
		store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
		components: {
			'settings': __WEBPACK_IMPORTED_MODULE_2__views_Settings_vue___default.a
		},
		render: function render(h) {
			return h('div', {
				attrs: {
					id: 'cf-pro-settings'
				}
			}, [h('settings')]);
		}
	});
}

//@TODO and this.


if (document.getElementById('cf-pro-app-tab')) {
	var tabApp = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
		el: '#cf-pro-app-tab',
		store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
		components: {
			'settings': __WEBPACK_IMPORTED_MODULE_4__views_Tab_vue___default.a
		},
		render: function render(h) {
			return h('div', {
				attrs: {
					id: 'cf-pro-settings-tab'
				}
			}, [h('settings')]);
		}
	});
}



/***/ })
]),[241]);


// WEBPACK FOOTER //
// client.ca043aad.js